import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Chat,
  Channel,
  MessageList,
  Window,
  Attachment,
  defaultRenderMessages,
  ChannelList,
} from "stream-chat-react";
import useChatClient from "../StatesStore/ChatClient";
import "stream-chat-react/dist/css/v2/index.css";
import { UserAuth } from "../Context";
import { Button, ButtonGroup, Card, Nav } from "react-bootstrap";
import { EmojiPicker } from "stream-chat-react/emojis";
import { encodeToMp3 } from "stream-chat-react/mp3-encoder";
import "./Chat.css";
import SideBar from "./SideBar";
import ProductCard3 from "../Products/ProductCard3";
import LoadingSpinner from "../UserProfile/LoadingSpinner";
import { ChannelHeader } from "./ChannelHeader";
import CustomMessageInput from "./CustomMessageInput";
import ProductsInChat from "./ProductsInChat";
import ChatFilter from "./ChatFilter";
import { getFilters } from "./lib.js/getFilters";
import useThemeState from "../StatesStore/Theme";
import CustomAttachment from "./CustomAttachment";
import { CustomAttachmentSelector } from "./CustomAttachmentSelector";
import useChatOpen from "../StatesStore/ChatOpen";
import useChatFilter from "../StatesStore/ChatFilter";
import { generateChatId } from "./lib.js/generateChatId";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";

function UserProfileChatMobile({ myUserId, profileUserId }) {
  const [loading, setLoading] = useState(true);
  const { user } = UserAuth();
  const navigate = useNavigate();
  // const { myUserId, profileUserId } = useParams();
  const client = useChatClient((state) => state.client);
  const { isChatOpen, setIsChatOpen, setIsChannelId, setIsChannel, setChannelType } = useChatOpen();
  const { chatFilterType } = useChatFilter();
  const { theme } = useThemeState();
  const [activeChannel, setActiveChannel] = useState(null);
  const [loadedFirstTime, setLoadedFirstTime] = useState(false);
  // const [channel, setChannel] = useState(null);
  const [msg, setMsg] = useState("");
  const [msgs, setMsgs] = useState([]);
  const [isRecipientOnline, setIsRecipientOnline] = useState(false);
  // const [channelId, setChannelId] = useState(null);
  const [recipientData, setRecipientData] = useState(null);

  useEffect(() => {
    if (!client || !user || !myUserId || !profileUserId) return;

    const setupChannel = async () => {
      try {
        setLoading(true);


        try {
          await client.queryUsers({ id: { $eq: profileUserId } });
        } catch (err) {
          console.error('Error checking user existence:', err);
        }

        const queryResponse = await client.queryUsers({ id: { $eq: profileUserId } });

        if (queryResponse.users.length === 0) {
          // If user does not exist, create them
          const docRef = doc(db, "users", profileUserId);
          const userData = await getDoc(docRef);
          const data = userData.data();
          // If user does not exist, create them
          await client.upsertUser({
            id: profileUserId,
            name: data.userName || "Unknown",
            image: data.photo || "",
            email: data.email || "",
          });
        }

        // Create a unique channel ID for the conversation
        const generatedChannelId = generateChatId(myUserId, profileUserId);
        setIsChannelId(generatedChannelId);

        // navigate(`/chat/${generatedChannelId}`);
        // Initialize the channel
        const channel = client.channel('messaging', generatedChannelId, {
          members: [myUserId, profileUserId],
        });

        console.log('userchatmobile channel', channel);

        await channel.watch();

        setIsChannel(channel);
        setChannelType('messaging')
        // setActiveChannel(channel);
        // setIsChatOpen(true);
        setLoading(false);
        // setLoadedFirstTime(true);

      } catch (error) {
        console.error("Error setting up Stream channel:", error);
        setLoading(false);
      }
    };

    setupChannel();

  }, [client, myUserId, profileUserId, user]);


  if (!user) return;

}

export default UserProfileChatMobile;